//#region INTERFACE IAutoOrderSupplierEmails

/**
 * ### Interface IAutoOrderSupplierEmails
 * Represents email addresses associated with an auto order supplier, including selected and additional emails.
 *
 * @interface IAutoOrderSupplierEmails
 * @extends Object
 * @description Contains the supplier's unique identifier along with arrays for selected and additional email addresses
 *              used in auto order communications.
 *
 * @example
 * const example: IAutoOrderSupplierEmails = {
 *   id: "supplier456",
 *   selected: ["primary@supplier.com"],
 *   additional: ["secondary@supplier.com", "notifications@supplier.com"]
 * };
 */
export interface IAutoOrderSupplierEmails extends Object {
  /**
   * Additional email addresses associated with the supplier.
   * @type {string[]}
   * @example ["secondary@supplier.com", "notifications@supplier.com"]
   */
  additional: string[];

  /**
   * Unique identifier for the supplier.
   * @type {string}
   * @example "supplier456"
   */
  id: string;

  /**
   * Selected primary email addresses for the supplier.
   * @type {string[]}
   * @example ["primary@supplier.com"]
   */
  selected: string[];
}

//#endregion
